export const IconClose = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width='13'
    height='13'
    viewBox='0 0 13 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12 1L1 12'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeMiterlimit='10'
    />
    <path
      d='M1 1L12 12'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeMiterlimit='10'
    />
  </svg>
)
